import { useMemo } from 'react';
import { RawAxiosRequestHeaders } from 'axios';

import { commonStore } from 'stores';

export const useGetHeaders = (): RawAxiosRequestHeaders => {
  const idToken = commonStore((state) => state.idToken);
  const accessToken = commonStore((state) => state.accessToken);

  const headers = useMemo(() => ({ 'Id-Token': idToken, Authorization: `Bearer ${accessToken}` }), [idToken, accessToken]);

  return headers;
};
